/**
 * 基金重仓行业 API（同源 /api/fund-industry）
 */
import { request } from './http'

/** 可用报告期列表：[{ period, reportDate, count, updatedAt }] */
export function fetchFundIndustryPeriods() {
  return request('/api/fund-industry/periods').then((data) => data.list || [])
}

/**
 * 某报告期行业持仓明细
 * @param {string} period 如 2026Q2
 */
export function fetchFundIndustryHoldings(period) {
  const q = new URLSearchParams({ period: String(period || '') })
  return request(`/api/fund-industry?${q}`).then((data) => data.list || [])
}

/**
 * 某报告期某行业的基金明细
 * @param {string} period 如 2026Q2
 * @param {string} code 证监会行业代码，如 A
 * @returns {{ period, reportDate, industryCode, industryName, list }}
 */
export function fetchFundIndustryFundDetails(period, code) {
  const q = new URLSearchParams({
    period: String(period || ''),
    code: String(code || '')
  })
  return request(`/api/fund-industry/funds?${q}`)
}
